export const accessibilityLabels = {
  /**
   * Aria label for the main ChiGo heading
   */
  heading: "Shy-Go (C-H-I-G-O)",
};
